import React, { FC, useEffect, useState } from 'react';
import Info from './Info';
import Form from './Form';
import InfoERP from './InfoERP';

interface IContact {
  contact: any;
  page?: 'erp' | null;
}

const social = {
  facebook: 'https://www.facebook.com/DigitalFreightAlliance_DPWorld',
  twitter: 'https://twitter.com/D_F_Alliance',
  linkedin: 'https://www.linkedin.com/company/digital-freight-alliance',
  youtube: 'https://www.youtube.com/c/SeaRatesOfficial/videos',
  instagram: 'https://www.instagram.com/searatesllc/',
};

export type TSocial = typeof social;

const Contact: FC<IContact> = ({ contact, page }): React.ReactElement => {
  const [isAuth, setIsAuth] = useState<boolean>(false);

  useEffect(() => {
    if (contact.name && contact.email) setIsAuth(true);
  }, []);

  return (
    <>
      <div className="contact">
        {page === 'erp' ? <InfoERP social={social} /> : <Info social={social} visible={contact.addressVisible} />}

        <Form isAuth={isAuth} contact={contact} page={page} />
      </div>
    </>
  );
};

export default Contact;
